import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HeartbeatSession } from 'src/app/utils/interfaces/new/heartbeat-session.interface';
import { environment } from 'src/environments/environment';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LoginService } from '../login/login.service';

@Injectable({
  providedIn: 'root'
})
export class HeartbeatService {

  private httpOptions = {
    withCredentials: true,
    observe: 'response' as 'response',
    headers: new HttpHeaders()
  };

  hearthbeatInterval: ReturnType<typeof setInterval>;
  inHearbeat = false;

  private apiUri = environment.basePath + '/auth/session-heartbeat';

  constructor(private _http: HttpClient,
    private _snackBar: MatSnackBar,
    private _loginService: LoginService) {
    this.callHeartbeat()
  }

  async callHeartbeat() {
    if (this.hearthbeatInterval) {
      clearInterval(this.hearthbeatInterval)
    }
    this.hearthbeatInterval = setInterval(async () => {
      if (!this.inHearbeat && this._loginService.getCurrentUser()) {
        this.inHearbeat = true;
        try {
          const res = await this._http.get(this.apiUri, this.httpOptions).toPromise();
          const infos = res.body as HeartbeatSession;
          if (infos && infos.sessionExpirationTime < 30) {
            this.openSnackBar(infos.sessionExpirationTime);
          }
        } catch (e) {
          console.warn(e);
        } finally {
          this.inHearbeat = false;
        }
      }
    }, 60 * 1000)
  }

  openSnackBar(minutes: number) {
    this._snackBar.open(`Expiration de la session dans ${minutes} minutes`, undefined, {
      duration: 5000,
      horizontalPosition: 'end',
    });
  }
}
